export interface Lookup{
 id : string,
 label:string,
 value?:string,
 index:number,
 checked?:boolean,
    key:string
}

export class Branch implements Lookup{
    id='';
    label='';
    value='';
    index=0
    key='';
    zoba:string='';
}

export class Country implements Lookup{
    id='';
    label='';
    value='';
    index=0
    currencyCode:string='';
    currencySymbol:string='';
    currencyLabel:string='';
    show:boolean|undefined=undefined;
    checked=false;
    key='';
}